jQuery(document).ready(function ($) {
  let controller = null

  $(".nomination_select").change(function () {
    var val = $(this).find(":selected").val()

    $(".single_add_to_cart_button").attr("disabled", "disabled")
    $(".woocommerce-notices-wrapper").empty()

    if (val != "") {
      display_buttons(val)
    }
  })

  $(".nomination_select").trigger("change")

  $("#price_override").keyup(function () {
    var val = $(this).val()
    var opinion = $(".nomination_select").find(":selected").val()
    $(".single_add_to_cart_button").attr("disabled", "disabled")

    if (controller) {
      controller.abort()
    }

    if ($(".licensing-fee > .loader_div").length == 0) {
      $(".licensing-fee").append('<div class="loader_div"></div>')
    }

    if ($(".licensing-fee > .loader_div").length > 0) {
      $(".loader_div").append('<div class="loader"></div>')
    }

    $(".woocommerce-notices-wrapper").empty()

    controller = $.ajax({
      url: RCOio__obj.ajax_url,
      method: "POST",
      data: {
        action: "validate_pending_amount",
        amount: val,
        opinion_hash: opinion,
      },
    })
      .success(function (data) {
        var response = JSON.parse(data)

        if (response) {
          if (response.success) {
            $(".single_add_to_cart_button").removeAttr("disabled")
          } else {
            $(".woocommerce-notices-wrapper").append(
              '<div class="woocommerce-message" role="alert">' +
                response.msg +
                "</div>"
            )
          }
        }
      })
      .always(function () {
        if ($(".licensing-fee > .loader_div").length > 0) {
          $(".loader_div").empty()
        }
      })
  })

  $(document).on("click", "#email_licensing", function () {
    var val = $(this).val()
    var opinion = $(this).data("opinion")
    $(".woocommerce-notices-wrapper").empty()

    notify_contact(opinion, "email")
  })

  $(document).on("click", "#sms_licensing", function () {
    var val = $(this).val()
    var opinion = $(this).data("opinion")
    $(".woocommerce-notices-wrapper").empty()

    notify_contact(opinion, "sms")
  })

  function notify_contact(opinion, type) {
    $("#email_licensing").attr("disabled", "disabled")
    $("#sms_licensing").attr("disabled", "disabled")
    $(".single_add_to_cart_button").attr("disabled", "disabled")

    if ($(".licensing-fee > .loader_div").length == 0) {
      $(".licensing-fee").append('<div class="loader_div"></div>')
    }

    if ($(".licensing-fee > .loader_div").length > 0) {
      $(".loader_div").append('<div class="loader"></div>')
    }

    $.ajax({
      url: RCOio__obj.ajax_url,
      method: "POST",
      data: {
        action: "licensing_notification",
        type: type,
        opinion_hash: opinion,
      },
    })
      .success(function (response) {
        if (
          $(".licensing-fee > .nomination_actions").length > 0 &&
          $(".price_override").length > 0
        ) {
          if ($(".price_override:hidden").length) {
            $(".price_override").show()
            $("#price_override").removeAttr("disabled")
          }
        }
      })
      .always(function () {
        $("#email_licensing").removeAttr("disabled")
        $("#sms_licensing").removeAttr("disabled")
        if ($(".licensing-fee > .loader_div").length > 0) {
          $(".loader_div").empty()
        }
      })
  }

  function display_buttons(val) {
    if ($(".licensing-fee > .nomination_actions").length == 0) {
      $(".licensing-fee").append('<div class="nomination_actions"></div>')
    }

    if ($(".licensing-fee > .nomination_actions").length > 0) {
      $(".nomination_actions").empty()
    }

    if ($(".price_override:visible").length) {
      $(".price_override").hide()
      $("#price_override").attr("disabled", "disabled")
    }

    if ($(".licensing-fee > .loader_div").length == 0) {
      $(".licensing-fee").append('<div class="loader_div"></div>')
    }

    if ($(".licensing-fee > .loader_div").length > 0) {
      $(".loader_div").append('<div class="loader"></div>')
    }

    var opinion = $(".nomination_select").find(":selected").val()
    let loggedIn = false
    $.ajax({
      url: RCOio__obj.ajax_url,
      method: "POST",
      data: {
        action: "check_login",
      },
    })
      .success(function (data) {
        if (data != "null") {
          var userData = JSON.parse(data)
          loggedIn = userData.loggedIn
        }
      })
      .always(function () {
        if (!loggedIn) {
          $.ajax({
            url: RCOio__obj.ajax_url,
            method: "POST",
            data: {
              action: "validate_opinion_contact",
              opinion_hash: val,
            },
          })
            .success(function (response) {
              if (response != "null") {
                var contact_information = JSON.parse(response)
                if (contact_information) {
                  if (
                    contact_information.contact_email ||
                    contact_information.contact_phone
                  ) {
                    $(".nomination_actions").append(
                      '<label for="notify_licensing" class="wppc_form-label">Notify me the remaining licensing amount</label>'
                    )
                    $(".nomination_actions").append("<br>")
                  }
                  if (
                    contact_information.contact_email &&
                    $(".licensing-fee > .nomination_actions").length > 0
                  ) {
                    $(".nomination_actions").append(
                      '<button class="button alt" type="button" id="email_licensing" data-opinion="' +
                        contact_information.opinion_hash +
                        '" value="email_licensing">' +
                        contact_information.contact_email +
                        "</button>"
                    )
                    $(".nomination_actions").append("<br>")
                    $(".nomination_actions").append("<br>")
                  }

                  if (
                    contact_information.contact_phone &&
                    $(".licensing-fee > .nomination_actions").length > 0
                  ) {
                    $(".nomination_actions").append(
                      '<button class="button alt" type="button" id="sms_licensing" data-opinion="' +
                        contact_information.opinion_hash +
                        '" value="sms_licensing">' +
                        contact_information.contact_phone +
                        "</button>"
                    )
                    $(".nomination_actions").append("<br>")
                    $(".nomination_actions").append("<br>")
                  }
                }
              } else {
                $(".single_add_to_cart_button").removeAttr("disabled")
              }
            })
            .always(function () {
              if ($(".licensing-fee > .loader_div").length > 0) {
                if ($(".licensing-fee > .loader_div").length > 0) {
                  $(".loader_div").empty()
                  $(".loader_div").empty()
                }
              }
            })
        } else {
          $.ajax({
            url: RCOio__obj.ajax_url,
            method: "POST",
            data: {
              action: "get_pending_amount",
              amount: val,
              opinion_hash: opinion,
            },
          })
            .success(function (data) {
              const response = JSON.parse(data)
              if (response.success) {
                $(".nomination_actions").append(
                  `<label for="notify_licensing" class="wppc_form-label">Remaining amount: <strong>$${response.msg}</strong></label>`
                )
                $(".nomination_actions").append("<br>")
                $("#price_override").val(
                  parseFloat(response.msg.replace(/,/g, ""))
                )
              }
            })
            .always(function () {
              $(".single_add_to_cart_button").removeAttr("disabled")
              if ($(".licensing-fee > .loader_div").length > 0) {
                $(".loader_div").empty()
              }
            })
        }
      })
  }

  // CUSTOM SELECT FOR BUTTON LABEL
  function $field(key) {
    return $('[name="' + key + '"], [name^="' + key + '["]')
  }

  function getVal(key) {
    return $field(key).val()
  }

  function setVal(key, value) {
    $field(key).val(value).trigger("change")
  }

  const LABEL_CUSTOM = "Custom Label"
  const LABEL_GOOGLE = "Click to leave us a 5 Star Google Review"

  function showConditional(selectValue) {
    $(".custom-voting--conditional").hide()
    $(".custom-voting--google-place").hide()
    $(".custom-voting--google-place-hid").hide()

    if (selectValue === LABEL_CUSTOM) {
      $(".custom-voting--custom-label").show()
    }

    if (selectValue === LABEL_GOOGLE) {
      $(".custom-voting--google-place").show()
    }
  }

  function buildGoogleReviewUrl(placeId) {
    // This is the commonly-used “write a review” deep link format
    return placeId
      ? `https://search.google.com/local/writereview?placeid=${encodeURIComponent(
          placeId
        )}`
      : ""
  }

  function maybeLockUrl(selectValue) {
    const $url = $('[name="custom-voting-button-url"]')

    if (selectValue === LABEL_GOOGLE) {
      $url.prop("readonly", true).css("background", "#f6f7f7")
    } else {
      $url.prop("readonly", false).css("background", "")
    }
  }

  function initPlacesAutocomplete() {
    if (!(window.google && google.maps && google.maps.places)) {
      return false
    }

    const input = document.querySelector(
      '[name="custom-voting-google-place-name"]'
    )
    if (!input) return true

    if (input._customVotingPlacesInit) return true
    input._customVotingPlacesInit = true

    const ac = new google.maps.places.Autocomplete(input, {
      fields: ["place_id", "name", "formatted_address"],
      types: ["establishment"],
    })

    ac.addListener("place_changed", function () {
      const place = ac.getPlace()
      const placeId = place?.place_id || ""
      setVal("custom-voting-google-place-id", placeId)

      if ($('[name="custom-voting-button-label"]').val() === LABEL_GOOGLE) {
        setVal("custom-voting-button-url", buildGoogleReviewUrl(placeId))
      }
    })

    return true
  }

  const $select = $('[name="custom-voting-button-label"]')

  function refresh() {
    const v = $('[name="custom-voting-button-label"]').val()
    showConditional(v)
    maybeLockUrl(v)

    if (v === LABEL_GOOGLE) {
      const placeId = getVal("custom-voting-google-place-id")
      if (placeId)
        setVal("custom-voting-button-url", buildGoogleReviewUrl(placeId))
    }
  }

  $select.on("change", refresh)
  refresh()

  // Toggle the entire After Vote Redirect Messaging area on/off
  const $enableToggle = $(
    '[name="custom-voting-page-enable-redirect"]'
  )
  function refreshRedirectArea() {
    const enabled = $enableToggle.is(":checked")
    $(".custom-voting--redirect-content").toggle(enabled)
    if (enabled) refresh()
  }
  $enableToggle.on("change", refreshRedirectArea)
  refreshRedirectArea()

  // Try init now and also retry after a short delay (in case header script loads late)
  initPlacesAutocomplete()
  setTimeout(initPlacesAutocomplete, 500)
  setTimeout(initPlacesAutocomplete, 1500)
  // END CUSTOM SELECT FOR BUTTON LABEL
})
